import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  userLoginDetails: '',
  userDetails     : '',
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/authentication/index.js